import 'regenerator-runtime/runtime'
import {
  ESignSignatoryExecutionServicePromiseClient,
  AdoptSignatureRequest,
  setRequest,
} from '@utils/index'

type Params = Partial<AdoptSignatureRequest.AsObject>

const {
  REACT_APP_QUERY_HOST = 'https://staging.pandolink.com',
  REACT_APP_QUERY_PORT = '443',
} = process.env

export const adoptSignature = async (params: Params, accessToken: string) => {
  const service = new ESignSignatoryExecutionServicePromiseClient(
    `${REACT_APP_QUERY_HOST}:${REACT_APP_QUERY_PORT}`
  )

  const request = setRequest(new AdoptSignatureRequest(), params)

  const result = await service.adoptSignature(request, {
    authorization: `Bearer ${accessToken}`,
  })

  return result
}
